// extracted by mini-css-extract-plugin
export var banner = "_1v-0";
export var icon = "_1v-1";
export var message = "_1v-2";